import {
  FormControl,
  FormLabel,
  Input,
  Select,
  SimpleGrid,
} from '@chakra-ui/react'
import { map } from 'lodash'
import { diagnosisTitles, roleTitles } from '../../../../types/FirestoreUser'
import { Filter } from '../types'

interface Props {
  list: boolean
  filter: Filter | undefined
  input: string
  studies: Record<string, string>
  onFilterChange: (filter: Filter) => void
  onInputChange: (input: string) => void
  inputRef?: React.RefObject<HTMLInputElement>
}

export default function UserFilters({
  list,
  filter,
  input,
  studies,
  onFilterChange,
  onInputChange,
  inputRef,
}: Props) {
  return (
    <SimpleGrid columns={[1, 2]} spacing={3}>
      <FormControl>
        <FormLabel>{list ? 'List By' : 'Search By'}</FormLabel>
        <Select
          placeholder={list ? 'Choose List Type' : 'Choose Search Type'}
          onChange={(e) => onFilterChange(e.target.value as Filter)}
          value={filter}
        >
          {list ? (
            <>
              <optgroup label='Alphabetical'>
                <option value='alphaFirst'>First Name</option>
                <option value='alphaLast'>Last Name</option>
                <option value='alphaEmail'>Email</option>
              </optgroup>
              <optgroup label='Diagnosis'>
                <option value='selectDiagnoses'>
                  ALS - MND - PLS - Probable ALS/MND/PLS
                </option>
                {map(diagnosisTitles, (text, key) => {
                  return (
                    <option value={key} key={key}>
                      {text}
                    </option>
                  )
                })}
              </optgroup>
              <optgroup label='Role'>
                <option value='patients'>{roleTitles['patient']}</option>
                <option value='admins'>{roleTitles['admin']}</option>
                <option value='superadmins'>{roleTitles['superadmin']}</option>
                <option value='testers'>{roleTitles['tester']}</option>
                <option value='researchers'>{roleTitles['researcher']}</option>
              </optgroup>
              <optgroup label='Studies'>
                {map(studies, (text, key) => {
                  // Use the study key (id) as the option value so filtering
                  // queries can match the stored study identifier in Firestore.
                  return (
                    <option value={key} key={key}>
                      {text}
                    </option>
                  )
                })}
              </optgroup>
            </>
          ) : (
            <>
              <option value='email'>Email</option>
              <option value='firstName'>First Name</option>
              <option value='lastName'>Last Name</option>
              <option value='patientId'>Patient ID</option>
            </>
          )}
        </Select>
      </FormControl>
      {!list && (
        <FormControl>
          <FormLabel>Value</FormLabel>
          <Input
            ref={inputRef}
            value={input}
            isDisabled={!filter}
            onChange={(e) => onInputChange(e.target.value)}
            placeholder='Value'
          />
        </FormControl>
      )}
    </SimpleGrid>
  )
}
